var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from 'react';
import WindowConfigContext from '../../context/window-config-context';
import WindowStateContext from '../../context/window-state-context';
import { hours, minutes, seconds } from '../../helpers/utils';
import useFocusableItem from '../../hooks/useFocusableItem';
import useInterval from '../../hooks/userInterval';
import { StyledTextInput } from '../TextInput';
var emptyVal = {
    from: 0,
    to: 0,
    countdownType: '',
    speed: 0,
    isNumber: true,
    isDescending: true,
};
var CoutDownInput = function (props) {
    var identifier = props.identifier, attributes = props.attributes, form = props.form, _a = props.type, type = _a === void 0 ? 'text' : _a, onChange = props.onChange, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "form", "type", "onChange", "children", "windowId"]);
    var enabled = attributes.enabled, readOnly = attributes.readOnly, otherAttributes = __rest(attributes, ["enabled", "readOnly"]);
    var stateFromEnv = useContext(WindowStateContext);
    var valuesFromEnv = stateFromEnv.fields;
    var _b = useState(''), itemVal = _b[0], setItemVal = _b[1];
    var _c = useState(null), intervalTime = _c[0], setIntervalTime = _c[1];
    var _d = useState(emptyVal), intervalVal = _d[0], setIntervalVal = _d[1];
    var config = useContext(WindowConfigContext);
    var onFocus = useFocusableItem(windowId, identifier, function () { }).onFocus;
    useEffect(function () {
        if (valuesFromEnv[identifier]) {
            var _a = valuesFromEnv[identifier], speed = _a.speed, from = _a.from, to = _a.to, countdownType = _a.countdownType, enabled_1 = _a.enabled;
            var isNumber = countdownType === 'number';
            setIntervalVal({
                speed: speed,
                from: isNumber ? from : from * 1000,
                to: isNumber ? to : to * 1000,
                countdownType: countdownType,
                isNumber: isNumber,
                isDescending: from > to,
            });
            setIntervalTime(enabled_1 ? speed : null);
        }
        else {
            setItemVal('');
        }
    }, [valuesFromEnv[identifier]]);
    useInterval(function () {
        var from = intervalVal.from, to = intervalVal.to, isNumber = intervalVal.isNumber, isDescending = intervalVal.isDescending;
        var doStep = function (prev) {
            if (isNumber) {
                return isDescending ? prev - 1 : prev + 1;
            }
            return isDescending ? prev - intervalTime : prev + intervalTime;
        };
        var val = doStep(from);
        if ((isDescending && val < to) || (!isDescending && to < val)) {
            setIntervalTime(null);
            return;
        }
        setIntervalVal(function (_intervalVal) { return (__assign(__assign({}, _intervalVal), { from: val })); });
        if (isNumber) {
            setItemVal("" + val);
        }
        else {
            var min = minutes(val);
            var sec = seconds(val);
            var hrs = hours(val);
            setItemVal(hrs + ":" + min + ":" + sec);
        }
    }, intervalTime);
    return (React.createElement(StyledTextInput, __assign({ type: type, id: identifier }, otherAttributes, restProps, { onFocus: onFocus, attributes: attributes, value: itemVal, readOnly: !config.isBuilder })));
};
export default CoutDownInput;
//# sourceMappingURL=index.js.map